import React from "react";
import styles from "./more-from-us-logo.module.scss";
import MyJohnLewisImg from "@/assets/images/logos/logo-my-john-lewis.svg";
import BuyAgainImg from "@/assets/images/logos/logo-buyagain.svg";
import GiftListImg from "@/assets/images/logos/logo-the-gift-list.svg";
import PartnershipCardImg from "@/assets/images/logos/logo-partnership-card.svg";
import JLInsuranceImg from "@/assets/images/logos/logo-john-lewis-insurance.svg";
import JLForeignCurrencyImg from "@/assets/images/logos/logo-john-lewis-foreign-currency.svg";
import JLBusinessImg from "@/assets/images/logos/logo-john-lewis-for-business.svg";
import WaitroseImg from "@/assets/images/logos/logo-waitrose-and-partners.svg";
import JLOpticiansImg from "@/assets/images/logos/logo-john-lewis-opticians.svg";
import WishListImg from "@/assets/images/logos/logo-wishlist.svg";

const logos = {
  myJohnLewis: MyJohnLewisImg,
  buyAgain: BuyAgainImg,
  giftList: GiftListImg,
  partnershipCard: PartnershipCardImg,
  jlInsurance: JLInsuranceImg,
  jlForeignCurrency: JLForeignCurrencyImg,
  jlBusiness: JLBusinessImg,
  waitrose: WaitroseImg,
  jlOpticians: JLOpticiansImg,
  wishList: WishListImg,
};

function MoreFromUsLogo({ element }) {
  const Logo = logos[element];
  return <img src={Logo.src} alt={element} className={styles[element]} />;
}

export default MoreFromUsLogo;
